import dynamic from 'next/dynamic';
import { BillingAndContactProps } from './BillingAndContact.types';

export const BillingAndContact = dynamic<{ model: BillingAndContactProps }>(() =>
  import('./BillingAndContact').then(mod => mod.BillingAndContact)
);
